import React from "react";
import * as m from "../lib/model";

// Small year-by-year war chest chart: cash deployed into add-ons vs cash still sitting in the chest,
// against the dashed line of what the next add-on's equity cheque costs.
export function WarChestTimeline({ M, testid = "sf-timeline" }) {
  const t = m.warChestTimeline(M);
  if (!t.rows.length) return null;
  const top = Math.max(t.need, ...t.rows.map((r) => r.end + r.spent), 1) * 1.08;
  const BAR = 96, LBL = 26;
  const h = (v) => `${Math.max(0, Math.min(BAR, (v / top) * BAR))}px`;
  return (
    <div className="wct" data-testid={testid}>
      <div className="wct-head">
        <span>War chest by year — <b>{m.fmt$(t.need)}</b> buys the next add-on{t.buffer > 0 ? ` (incl. ${m.fmt$(t.buffer)} buffer)` : ""}</span>
        <span className="wct-key"><i className="k-spent" /> deployed into add-ons <i className="k-free" /> cash still in the chest</span>
      </div>
      <div className="wct-plot">
        <div className="wct-need" style={{ bottom: `${LBL + Math.min(BAR, (t.need / top) * BAR)}px` }}><span>{m.fmt$(t.need)}</span></div>
        <div className="wct-cols">
          {t.rows.map((r) => (
            <div className="wct-col" key={r.y} data-testid={`${testid}-yr-${r.y}`}>
              <div className="wct-tip" data-testid={`${testid}-tip-${r.y}`}>
                <b>Yr {r.y} — {m.fmt$(r.end)} available</b>
                <span>{m.fmt$(r.inflow)} retained in</span>
                {r.buys ? <span>{r.buys} add-on{r.buys === 1 ? "" : "s"} bought · {m.fmt$(r.spent)}</span> : <span>no add-on bought</span>}
                <span>{r.shortfall > 0 ? `${m.fmt$(r.shortfall)} short of the next ${m.fmt$(t.need)} cheque` : "covers the next cheque"}</span>
              </div>
              <div className="wct-bar">
                <div className="wct-free" style={{ height: h(r.end) }} />
                <div className="wct-spent" style={{ height: h(r.spent) }} />
              </div>
              <b className={r.buys ? "wct-badge on" : "wct-badge"} data-testid={`${testid}-buys-${r.y}`}>{r.buys ? `${r.buys}×` : "—"}</b>
              <span className="wct-lbl">Yr {r.y}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
